import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputDateUI from '../../../widgets/form/InputDateUI'

const CreditAssessmentDateModalUI = ({context, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    // superuser role
    creditAssessmentDate, onDateChange, dateError, setDateError
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Update date'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputDateUI context={context} name='date' label='Credit assessment date'
      selectedDateISO={creditAssessmentDate} onChange={onDateChange}
      error={dateError} setError={setDateError}
    />
  </ModalFormUI>

export default CreditAssessmentDateModalUI
